import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Message } from "../models/AppointmentChatModel/AppointmentChat.model";

interface MessagesState {
  messages: Message[];
}

const initialState: MessagesState = {
  messages: [],
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessages(state, action: PayloadAction<Message[]>) {
      state.messages = action.payload;
    },
    addNewMessage(state, action: PayloadAction<Message>) {
      state.messages = [...state.messages, action.payload];
    }
  },
});

export const { setMessages, addNewMessage } = messagesSlice.actions;

export default messagesSlice.reducer;
